import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingModal = ({ title, onShow, handleClose }) => {
  if (!onShow) return null;

  return (
    <div className="page-loading-overlay">
      <div className="text-center p-4">
        <Spinner animation="border" variant="danger" size="lg" />
        <p className="mt-3 mb-0 text-dark fw-bold" style={{ fontSize: "1.1rem" }}>
          {title || "Please Wait..."}
        </p>
      </div>
    </div>
  );
};

export default LoadingModal;
